module.exports = __webpack_public_path__ + "media/recipes/118-ce0541c1.png";